import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=672f9b98&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=672f9b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f9b98",
  null
  
)

export default component.exports